import { default as on_site } from ":src/modules/help-portal/on-site/routes";
import { default as faq_inquiry } from ":src/modules/help-portal/faq-inquiry/routes";
import { default as profile } from ":src/modules/account/profile/routes";
export default {
  BASE: "/support",
  on_site,
  faq_inquiry,
  profile,
};
